export enum InitRoute {
  selectEnterprise = 'select-enterprise',
  dashboard = 'dashboard',
  profile = 'profile',
  inventory = 'inventory',
  fiscal = 'fiscal',
  database = 'database',
  contabilidad = 'contabilidad',
  rbac = 'rbac',
}
